import React, { useEffect, useState } from 'react';
import mapFieldsToData from '../../helpers/mapFieldsToData';
import http from '../../service'
import ListPage from '../../Components/ListPage';
import PlantingLotsIcon from '../../images/PlantingLotsIcon';
import * as S from './Groups.style';
import * as constants from './Groups.constants';

export default function Groups ({setModal}) {
  const { groupsSearchFieldsState, groupsSearchFields } = constants;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [page, setPage] = useState(1);
  const [list, setList] = useState([]);
  const [totalPages, setTotalPages] = useState('');
  const [totalCount, setTotalCount] = useState('');
  const [fields, setFields] = useState(groupsSearchFieldsState);
  const searchFields = groupsSearchFields({fields});
  const listPageObject = {
    ...constants, loading, error, page, totalPages, totalCount, list, fields: searchFields,
    setLoading, setError, setPage, setTotalPages, setTotalCount, icon: PlantingLotsIcon, setList, setFields, 
  }

  useEffect(() => {
    const params = mapFieldsToData({fields: searchFields});
    http.get('grupo', { params })
      .then(({ data }) => setList(data))
      .catch((err) => setModal({ isOpen: true, text: err.message }))

  }, [])

  return (
    <S.Groups>
      <ListPage {...listPageObject} />
    </S.Groups>
  );
};
